import { Breakpoint, Markdown } from '@elearning-platform/ui';
import { styled } from 'styled-components';

import { AccordionsWrapperProps } from './centeredContentSlide.types';

export const DescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledDescription = styled(Markdown)`
  flex-direction: column;
`;

export const AccordionsWrapper = styled.div<AccordionsWrapperProps>`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;

  @media ${Breakpoint.SmallDesktop} {
    grid-template-columns: ${({ $isTwoColumns }: AccordionsWrapperProps): string => $isTwoColumns ? '1fr 1fr' : '1fr'};
  }
`;
